export const SET_ID = (state, value) => {
  state.id = value
}

export const SET_TYPE = (state, value) => {
  state.type = value
}

export const SET_RESIDENCE = (state, value) => {
  state.residence = value
}

export const SET_TRADENAME = (state, value) => {
  state.tradeName = value
}

export const SET_NAME = (state, value) => {
  state.name = value
}

export const SET_LASTNAME = (state, value) => {
  state.lastName = value
}

export const SET_DOCUMENT = (state, value) => {
  state.document = value
}

export const SET_MERCANTILEREGISTRY = (state, value) => {
  state.settings.mercantileRegistry = value
}

export const SET_ACCOUNTASSIGNEDID = (state, value) => {
  state.settings.accountAssignedId = value
}

export const SET_IRPF = (state, value) => {
  state.settings.irpf = value
}

export const SET_GREENPOINT = (state, value) => {
  if (!['none', '2', '3'].includes(value)) value = 'none'
  state.settings.greenPoint = value
}

export const SET_TERMS_AND_CONDITIONS = (state, value) => {
  state.terms = value
}

export const SET_REGIME = (state, value) => {
  state.settings.specialRegime = value
}

export const SET_TICKETBAIREQUIRED = (state, value) => {
  state.settings.ticketbaiRequired = value
}

export const SET_SIIREQUIRED = (state, value) => {
  state.settings.siiRequired = value
}

export const SET_HEADINGBIZKAIA = (state, value) => {
  state.settings.headingBizkaia = value
}

export const SET_UNAUTHORIZED = (state, value) => {
  state.unauthorized = value
}

export const SET_ISSUED_INVOICES = (state, value) => {
  state.issuedInvoices = value
}

export const SET_MAX_INVOICES = (state, value) => {
  state.maxIssuedInvoices = value
}
